import type { CSSProperties } from 'react'

type AppLinkProps = {
  name: string;
  description?: string | null;
  href: string;
  color: string;
  textColor?: string;
}

export default function AppLink({ name, description, href, color, textColor }: AppLinkProps) {
  return (
    <a className="card-box" style={{ '--card-bg': color, '--card-text': textColor ?? '#ffffff' } as CSSProperties} href={href} target="_blank" rel="noreferrer">
      <div className="card h-100">
        <div className="card-body d-flex flex-column justify-content-center align-items-center">
          <h3 className="card-title">{name}</h3>
          {description && <p className="card-text mb-0 mt-1">{description}</p>}
        </div>
      </div>
    </a>
  )
}
